module.exports = __webpack_public_path__ + "img/screenshot-add.cc627346.jpg";